export enum InvoiceRowType {
    Text = 0,
    Product = 1,
    TransportOrder = 2,
    Footer = 3
}
